import React, { PureComponent } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from "react-bootstrap/Container";
import Card from 'react-bootstrap/Card';

class PrintedTestsWarning extends PureComponent {
  render() {
    return (
      <Container fluid>
        <Row className="printed__papers__container">
            <Card>
                <Row>
                <Col xs={12} sm="auto" className="printed__papers__icon">
                    <i className="fas fa-info-circle"></i>
                </Col>
                <Col xs={12} sm={11} className="printed__papers__info">
                    {/* UNCOMMENT THIS WHEN TST ORDERING REOPENS
                    <h4>Please note: a Complete Primary Package subscription is required to order printed tests.</h4>
                    <p>Please ensure you have renewed your current subscription before purchase.</p>*/}
                    <h4 className="reopen__info">Ordering for printed Spring Standardised Tests will be available in November 2024</h4>
                </Col>
                </Row>
            </Card>
        </Row>
      </Container>
    );
  }
}

export default PrintedTestsWarning;
